import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('booking-room/index', {params});
    },
    getMeetingRoom(params) {
        return Service().get('booking-room/get-booking-room', {params});
    },
    show(id) {
        return Service().get('booking-room/show/'+id);
    },
    create(params) {
        return Service().post('booking-room/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('booking-room/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('booking-room/delete/'+id);
    },
    getScheduleMeeting(params) {
        return Service().get('booking-room/get-schedule-meeting', {params});
    },
}